
import { Import4YouInventory, Import4YouSubInventory } from "@domain/connection/models/Import4YouInventory";

export class Import4YouMapper {
    static toInventoryModel(dto: Import4YouInventory): Import4YouInventory {
        return {
            id: dto.id,
            connection_id: dto.connection_id,
            personal_ref: dto.personal_ref,
            product_id: dto.product_id,
            start_boxes_count: dto.start_boxes_count,
            boxes_count: dto.boxes_count,
            created_at: new Date(dto.created_at),
            boxes_without_pallets: dto.boxes_without_pallets,
            pallets: dto.pallets,
            warehouse_sub_inventory: dto.warehouse_sub_inventory.map(subInventory => Import4YouMapper.toSubInventoryModel(subInventory)),
            updated_at: new Date(dto.updated_at),
            product_map: dto.product_map ? {
                juststock_product_id: dto.product_map.juststock_product_id,
                products_per_box: dto.product_map.products_per_box
            } : undefined,
        };
    }

    static toSubInventoryModel(dto: Import4YouSubInventory): Import4YouSubInventory {
        return {
            id: dto.id,
            connection_id: dto.connection_id,
            personal_ref: dto.personal_ref,
            product_id: dto.product_id,
            product_sub_id: dto.product_sub_id,
            start_warehouse_boxes: dto.start_warehouse_boxes,
            warehouse_boxes: dto.warehouse_boxes,
            boxes_per_pallet: dto.boxes_per_pallet,
            amount_of_pallets: dto.amount_of_pallets,
            balance_pallet: dto.balance_pallet,
            updated_at: new Date(dto.updated_at),
            product_map: dto.product_map ? {
                juststock_product_id: dto.product_map.juststock_product_id,
                products_per_box: dto.product_map.products_per_box
            } : undefined,
        };
    }
} 